var map = {
	"./NEXT-Book/NEXT-Book-Bold.woff": 86326,
	"./NEXT-Book/NEXT-Book-Bold.woff2": 54240,
	"./NEXT-Book/NEXT-Book-Regular.woff": 22955,
	"./NEXT-Book/NEXT-Book-Regular.woff2": 15667
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 49856;